/**
 * Module Constants for Permission System
 * This file contains all module IDs used in the permission system
 * Add new modules here as they are created
 */

export const MODULE_IDS = {
  // Dashboard
  DASHBOARD: 'dashboard',
  GENERAL_SETTINGS: 'general-settings',
  
  // User Settings
  USER: 'user',
  USER_RIGHTS: 'user-rights',
  
  // Masters
  COMPANY: 'company',
  BROKER: 'broker',
  AREA: 'area',
  BANKS: 'banks',
  SALES_PERSON: 'sales-person',
  PIPE_TYPE: 'pipe-type',
  SCHEDULE: 'schedule',
  TRANSPORTER: 'transporter',
  HSN_CODE: 'hsncode',
  ITEM: 'item',
  ACCOUNT: 'account',
  DESIGN: 'design',
  LOT: 'lot',
  BOOK: 'book',
  REPORT_MASTER: 'report-master',
  WORKER: 'worker-master',
  GRADE: 'grade',
  TDS_SECTION: 'tds-section',
  JOB: 'job',
  VEHICLE: 'vehicle',
  MACHINE: 'machine',
  BRANCH: 'branch',
  BOBIN_TYPE: 'bobin-type',
  ITEM_LOT_RATE: 'item-lot-rate',
  ACCOUNT_ITEM_RATE: 'account-item-rate',
  
  // Inventory
  BEAM: 'beam',
  PRODUCTION_ENTRY: 'production-entry',
  PRODUCTION_REPACKING_ENTRY: 'production-repacking-entry',
  PRODUCTION_PURCHASE_ENTRY: 'production-purchase-entry',
  DELIVERY_CHALLAN_ENTRY: 'delivery-challan-entry',
  DELIVERY_CHALLAN_RETURN: 'delivery-challan-return-entry',
  GRAY_JOB_ISSUE: 'gray-job-issue',
  GRAY_JOB_RECEIVE: 'gray-job-receive',
  GRAY_JOB_RETURN: 'gray-job-return',
  SUB_JOB_ISSUE_ENTRY: 'sub-job-issue-entry',
  SUB_JOB_RECEIVE: 'sub-job-receive',
  SUB_JOB_RETURN: 'sub-job-return',
  SHORT_EXCESS: 'short-excess',
  WORKER_ATTENDANCE_MONTHLY: 'worker-attendance-monthly',
  WORKER_UPAD: 'worker-upad',
  WORKER_JAMA: 'worker-jama',
  WORKER_ATTENDANCE_DAILY: 'worker-attendance-daily',
  RAW_MATERIAL_INWARD_CHALLAN: 'raw-material-inward-challan',
  RAW_MATERIAL_ISSUE_CHALLAN: 'raw-material-issue-challan',
  RAW_MATERIAL_RETURN_CHALLAN: 'raw-material-return-challan',
  DATE_WISE_PRODUCTION: 'date-wise-production',
  DATE_WISE_PRODUCTION_DIFFERENCE: 'date-wise-production-difference',
  VEHICLE_UPAD: 'vehicle-upad',
  VEHICLE_SALARY: 'vehicle-salary',
  JOB_YARN_ISSUE: 'job-yarn-issue',
  JOB_YARN_RECEIVE: 'job-yarn-receive',
  JOB_YARN_RETURN: 'job-yarn-return',

  // Transactions
  SALES_ORDER: 'sales-order',
  SALES_BILL: 'sales-bill',
  SALES_RETURN: 'sales-return',
  PURCHASE_ORDER: 'purchase-order',
  PURCHASE_CHALLAN: 'purchase-challan',
  PURCHASE_CHALLAN_RETURN: 'purchase-challan-return',
  PURCHASE_BILL: 'purchase-bill',
  PURCHASE_BILL_RETURN: 'purchase-bill-return',
  GENERAL_PURCHASE_BILL: 'general-purchase-bill',
  GENERAL_PURCHASE_RETURN_BILL: 'general-purchase-return-bill',
  JOURNAL_VOUCHER: 'journal-voucher',
  JOURNAL_VOUCHER_MULTY: 'journal-voucher-multy',
  DEBIT_NOTE: 'debit-note',
  CREDIT_NOTE: 'credit-note',
  DEBIT_NOTE_BILL_BASE: 'debit-note-bill-base',
  CREDIT_NOTE_BILL_BASE: 'credit-note-bill-base',
  DEBIT_NOTE_BILL_BASE_RETURN: 'debit-note-bill-base-return',
  CREDIT_NOTE_BILL_BASE_RETURN: 'credit-note-bill-base-return',
  BANK_RECEIPT: 'bank-receipt',
  BANK_PAYMENT: 'bank-payment',
  BANK_RECEIPT_RETURN: 'bank-receipt-return',
  BANK_PAYMENT_RETURN: 'bank-payment-return',
  CASH_RECEIPT: 'cash-receipt',
  CASH_PAYMENT: 'cash-payment',
  BANK_SLIP_ENTRY: 'bank-slip-entry',
  BANK_PAYMENT_SLIP_ENTRY: 'bank-payment-slip-entry',
  IMPORT_BANK_STATEMENT: 'import-bank-statement',
  
  
  // Daybook Reports
  SALES_REPORT: 'sales-register',
  SALES_RETURN_REPORT: 'sales-return-register',
  SALES_ORDER_REPORT: 'sales-order-register',
  PURCHASE_REPORT: 'purchase-register',
  PURCHASE_RETURN_REPORT: 'purchase-return-register',
  PURCHASE_ORDER_REPORT: 'purchase-order-register',
  GENERAL_PURCHASE_REPORT: 'general-purchase-register',
  GENERAL_PURCHASE_RETURN_REPORT: 'general-purchase-return-register',
  JOURNAL_VOUCHER_REPORT: 'journal-voucher-register',
  DEBIT_CREDIT_NOTE_REPORT: 'debit-credit-not-register',
  DEBIT_CREDIT_NOTE_BILL_BASE_REPORT: 'debit-credit-note-bill-base-register',
  BANK_CASH_REPORT: 'bank-cash-register',
   
  // Outstanding Report
  SALES_OUTSTANDING_REPORT: 'sales-outstanding-register',
  PURCHASE_OUTSTANDING_REPORT: 'purchase-outstanding-register',
  GENERAL_PURCHASE_OUTSTANDING_REPORT: 'general-purchase-outstanding-register',
  SALES_INTEREST_CALCULATION_REPORT: 'sales-intrest-calculation-register',
  PURCHASE_INTEREST_CALCULATION_REPORT: 'purchase-intrest-calculation-register',
  SALES_PAID_BILL_REPORT: 'sales-paid-bill-detail-register',
  PURCHASE_PAID_BILL_REPORT: 'purchase-paid-bill-detail-register',
  
  // Unadjust Bill Reports
  UNADJUST_BILL_SALES_RETURN_REPORT: 'sales-return-unadjust-bill-register',
  UNADJUST_BILL_PURCHASE_RETURN_REPORT: 'purchase-return-unadjust-bill-register',
  UNADJUST_BILL_BANK_RECEIPT_REPORT: 'bank-receipt-unadjust-bill-register',
  UNADJUST_BILL_BANK_PAYMENT_REPORT: 'bank-payment-unadjust-bill-register',
  UNADJUST_BILL_CASH_RECEIPT_REPORT: 'cash-receipt-unadjust-bill-register',
  UNADJUST_BILL_CASH_PAYMENT_REPORT: 'cash-payment-unadjust-bill-register',
  UNADJUST_BILL_DEBIT_NOTE_REPORT: 'debit-note-unadjust-bill-register',
  UNADJUST_BILL_CREDIT_NOTE_REPORT: 'credit-note-unadjust-bill-register',
  UNADJUST_BILL_GENERAL_PURCHASE_REPORT: 'general-purchase-return-unadjust-bill-register',

  // GST Reports
  GSTR1_REPORT: 'gstr1-report',
  GSTR2_REPORT: 'gstr2-report',
  GSTR3B_REPORT: 'gstr3b-report',
  GST_DETAIL_REPORT: 'gst-detail-report',
  GST_REGISTER_REPORT: 'gst-register-report',
  GSTR9_REPORT: 'gstr9-report',
  TDS_REPORT: 'tds-report',
  TCS_REPORT: 'tcs-report',
  CANCEL_EWAY_BILL_REPORT: 'cancel-eway-bill-report',
  GST_REFUND_REPORT: 'gst-refund-report',
  REVERSE_GST_CHARGE_REPORT: 'reverse-gst-charge-report',
  GST_LEDGER_REPORT: 'gst-ledger-report',
  
  // Financial Reports
  LEDGER_REPORT: 'ledger-report',
  BANK_RECO_LEDGER_REPORT: 'bank-reconciliation-ledger-report',
  TRIAL_BALANCE_SCHEDULE_WISE_REPORT: 'trial-balance-schedule-report',
  TRADING_ACCOUNT_REPORT: 'trading-account-report',
  PROFIT_LOSS_ACCOUNT_REPORT: 'profit-loss-account-report',
  BALANCE_SHEET_REPORT: 'balance-sheet-report',

  //stock-detail Reports
  NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT: 'non-issue-ready-goods-yarn-stock',
  NON_ISSUE_READY_GOODS_GRAY_STOCK_REPORT: 'non-issue-ready-goods-gray-stock',
  NON_ISSUE_RAW_MATERIAL_STOCK_REPORT: 'non-issue-raw-material-stock',
  SUB_JOB_PENDING_STOCK_RECEIVE_GRAY_REPORT: 'sub-job-pending-stock-receive-gray',
  SUB_JOB_PENDING_STOCK_RECEIVE_YARN_REPORT: 'sub-job-pending-stock-receive-yarn',
  KARIGAR_SALARY_REPORT: 'karigar-salary-report',

  //stock-detail Reports
  SALES_ORDER_BALANCE_BILL_BASE: 'sales-order-balance-report-bill-base',
  SALES_ORDER_BALANCE_CHALLAN_BASE: 'sales-order-balance-report-challan-base',
  PURCHASE_ORDER_BALANCE_BILL_BASE: 'purchase-order-balance-report-bill-base',
  PURCHASE_ORDER_BALANCE_CHALLAN_BASE: 'purchase-order-balance-report-challan-base',
  MACHINE_WISE_BEAM_STOCK: 'machine-wise-beam-stock',
  PRODUCTION_DETAIL_GRAY_REPORT: 'production-detail-gray-report',
  PRODUCTION_DETAIL_YARN_REPORT: 'production-detail-yarn-report',
  SHORT_EXCESS_REGISTER: 'short-excess-register',
  ITEM_LEDGER_REPORT: 'item-ledger-report',
  PURCHASE_BILL_SALES_BALANCE: 'purchase-bill-sales-balance-report',
  ORDER_DELIVERY_SCHEDULE_BALANCE_CHALLAN_BASE: 'order-delivery-schedule-balance-detail-report',
  DATE_WISE_PRODUCTION_STOCK_REPORT: 'date-wise-production-stock-report',
  PURCHASE_SALE_ORDER_BALANCE_REPORT: 'purchase-sales-order-balance-report',
  KARIGAR_SALARY_REPORT: 'karigar-salary-report',
  JOB_YARN_STOCK_REPORT: 'job-yarn-stock-report',
  JOB_YARN_IN_OUT_REPORT: 'job-yarn-in-out-report',

  // inventory reports
  PPROCUTION_REGISTER_YARN_REPORT: 'production-register-yarn',
  DELIVERY_CHALLAN_REGISTER_YARN_REPORT: 'delivery-challan-register-yarn',
  DELIVERY_CHALLAN_REGISTER_RETURN_YARN_REPORT: 'delivery-challan-register-return-yarn',
  PPROCUTION_REGISTER_GRAY_REPORT: 'production-register-gray',
  DELIVERY_CHALLAN_REGISTER_GRAY_REPORT: 'delivery-challan-register-gray',
  DELIVERY_CHALLAN_REGISTER_RETURN_GRAY_REPORT: 'delivery-challan-register-return-gray',
  BEAM_REGISTER_REPORT: 'beam-register',

  //Utility
  LOCK_DATA: 'lock-data',
  IMPORT_DATA: 'import-data',
  IMPORT_FROM_CUSTOMER: 'import-from-customer',
  IMPORT_FROM_PDF: 'import-from-pdf',
  SCAN_WHATSAPP_DEVICE: 'scan-whatsapp-device',
  DB_BACKUP: 'db-backup',
  REMINDER: 'reminder',
  YEAR_END_PROCESS: 'year-end-process',

  //super-admin
  STATE: 'state',

  // other
  MAIL_TEMPLATE: 'mail-template',

  // DRAFT
  DRAFT_DEBIT_NOTE_BILL_BASE: 'draft-debit-note-bill-base',
  DRAFT_CREDIT_NOTE_BILL_BASE: 'draft-credit-note-bill-base',
};

/**
 * Module Groups for easier permission management
 */
export const MODULE_GROUPS = {
  DASHBOARD: [MODULE_IDS.DASHBOARD],
  
  // ADMIN_MASTERS: [
  //   MODULE_IDS.CUSTOMER,
  //   MODULE_IDS.MODULE,
  //   MODULE_IDS.CUSTOMER_RIGHTS,
  //   MODULE_IDS.FINYEAR,
  //   MODULE_IDS.STATE,
  //   MODULE_IDS.UOM,
  //   MODULE_IDS.INDUSTRY_TYPE,
  // ],
  
  USER_SETTINGS: [
    MODULE_IDS.USER,
    MODULE_IDS.USER_RIGHTS,
  ],
  
  MASTERS: [
    MODULE_IDS.ACCOUNT,
    MODULE_IDS.AREA,
    MODULE_IDS.BANKS,
    MODULE_IDS.SALES_PERSON,
    MODULE_IDS.PIPE_TYPE,
    MODULE_IDS.BOOK,
    MODULE_IDS.BROKER,
    MODULE_IDS.COMPANY,
    MODULE_IDS.DESIGN,
    MODULE_IDS.GRADE,
    MODULE_IDS.GROUP,
    MODULE_IDS.HSN_CODE,
    MODULE_IDS.ITEM,
    MODULE_IDS.LOT,
    MODULE_IDS.REPORT,
    MODULE_IDS.SCHEDULE,
    MODULE_IDS.TDS_SECTION,
    MODULE_IDS.TRANSPORTER,
    MODULE_IDS.WORKER,
    MODULE_IDS.MACHINE,
    MODULE_IDS.BRANCH,
    MODULE_IDS.BOBIN_TYPE,
    MODULE_IDS.ITEM_LOT_RATE,
  ],
  
  TRANSACTIONS: [
    MODULE_IDS.SALES_BILL,
    MODULE_IDS.SALES_RETURN,
    MODULE_IDS.SALES_ORDER,
    MODULE_IDS.PURCHASE_BILL,
    MODULE_IDS.PURCHASE_BILL_RETURN,
    MODULE_IDS.PURCHASE_CHALLAN,
    MODULE_IDS.PURCHASE_ORDER,
    MODULE_IDS.GENERAL_PURCHASE_BILL,
    MODULE_IDS.GENERAL_PURCHASE_RETURN_BILL,
    MODULE_IDS.PURCHASE_CHALLAN_RETURN,
    MODULE_IDS.BANK_RECEIPT,
    MODULE_IDS.BANK_PAYMENT,
    MODULE_IDS.BANK_RECEIPT_RETURN,
    MODULE_IDS.BANK_PAYMENT_RETURN,
    MODULE_IDS.CASH_RECEIPT,
    MODULE_IDS.CASH_PAYMENT,
    MODULE_IDS.JOURNAL_VOUCHER,
    MODULE_IDS.JOURNAL_VOUCHER_MULTY,
    MODULE_IDS.DEBIT_NOTE,
    MODULE_IDS.CREDIT_NOTE,
    MODULE_IDS.DEBIT_NOTE_BILL_BASE,
    MODULE_IDS.CREDIT_NOTE_BILL_BASE,
    MODULE_IDS.DEBIT_NOTE_BILL_BASE_RETURN,
    MODULE_IDS.CREDIT_NOTE_BILL_BASE_RETURN,
  ],
  
  INVENTORY: [
    MODULE_IDS.BEAM,
    MODULE_IDS.PRODUCTION_ENTRY,
    MODULE_IDS.DELIVERY_CHALLAN_ENTRY,
    MODULE_IDS.DELIVERY_CHALLAN_RETURN,
    MODULE_IDS.GRAY_JOB_ISSUE,
    MODULE_IDS.GRAY_JOB_RECEIVE,
    MODULE_IDS.GRAY_JOB_RETURN,
    MODULE_IDS.SUB_JOB_ISSUE_ENTRY,
    MODULE_IDS.SUB_JOB_RECEIVE,
    MODULE_IDS.RAW_MATERIAL_INWARD_CHALLAN,
    MODULE_IDS.RAW_MATERIAL_ISSUE_CHALLAN,
    MODULE_IDS.RAW_MATERIAL_RETURN_CHALLAN,
    MODULE_IDS.DATE_WISE_PRODUCTION,
    MODULE_IDS.DATE_WISE_PRODUCTION_DIFFERENCE,
  ],
  
  REPORTS: [
    MODULE_IDS.SALES_REPORT,
    MODULE_IDS.SALES_RETURN_REPORT,
    MODULE_IDS.SALES_ORDER_REPORT,
    MODULE_IDS.PURCHASE_REPORT,
    MODULE_IDS.PURCHASE_RETURN_REPORT,
    MODULE_IDS.PURCHASE_ORDER_REPORT,
    MODULE_IDS.GENERAL_PURCHASE_REPORT,
    MODULE_IDS.GENERAL_PURCHASE_RETURN_REPORT,
    MODULE_IDS.DEBIT_CREDIT_NOTE_REPORT,
    MODULE_IDS.DEBIT_CREDIT_NOTE_BILL_BASE_REPORT,
    MODULE_IDS.JOURNAL_VOUCHER_REPORT,
    MODULE_IDS.SALES_OUTSTANDING_REPORT,
    MODULE_IDS.PURCHASE_OUTSTANDING_REPORT,
    MODULE_IDS.GENERAL_PURCHASE_OUTSTANDING_REPORT,
  ],
  
  UNADJUST_BILL_REPORTS: [
    MODULE_IDS.UNADJUST_BILL_SALES_RETURN_REPORT,
    MODULE_IDS.UNADJUST_BILL_PURCHASE_RETURN_REPORT,
    MODULE_IDS.UNADJUST_BILL_BANK_RECEIPT_REPORT,
    MODULE_IDS.UNADJUST_BILL_BANK_PAYMENT_REPORT,
    MODULE_IDS.UNADJUST_BILL_CASH_RECEIPT_REPORT,
    MODULE_IDS.UNADJUST_BILL_CASH_PAYMENT_REPORT,
    MODULE_IDS.UNADJUST_BILL_DEBIT_NOTE_REPORT,
    MODULE_IDS.UNADJUST_BILL_CREDIT_NOTE_REPORT,
    MODULE_IDS.UNADJUST_BILL_GENERAL_PURCHASE_REPORT,
  ],
  
  FINANCIAL_REPORTS: [
    MODULE_IDS.BANK_CASH_REPORT,
    MODULE_IDS.LEDGER_REPORT,
  ],
  
  GST_REPORTS: [
    MODULE_IDS.GSTR1_REPORT,
    MODULE_IDS.GSTR2_REPORT,
    MODULE_IDS.GSTR3B_REPORT,
    MODULE_IDS.GSTR9_REPORT,
    MODULE_IDS.GST_DETAIL_REPORT,
    MODULE_IDS.GST_REGISTER_REPORT,
  ],
  
  OTHER_REPORTS: [
    MODULE_IDS.SALES_INTEREST_CALCULATION_REPORT,
    MODULE_IDS.PURCHASE_INTEREST_CALCULATION_REPORT,
    MODULE_IDS.SALES_PAID_BILL_REPORT,
    MODULE_IDS.PURCHASE_PAID_BILL_REPORT,
    MODULE_IDS.TDS_REPORT,
    MODULE_IDS.TCS_REPORT,
    MODULE_IDS.NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT,
    MODULE_IDS.MACHINE_WISE_BEAM_STOCK,
  ],
  
  SETTINGS: [
    MODULE_IDS.GENERAL_SETTINGS,
    MODULE_IDS.BILL_ADJUSTMENT,
  ],

  UTILITIES: [
    MODULE_IDS.LOCK_DATA,
    MODULE_IDS.IMPORT_DATA,
    MODULE_IDS.IMPORT_FROM_CUSTOMER,
    MODULE_IDS.IMPORT_FROM_PDF,
    MODULE_IDS.SCAN_WHATSAPP_DEVICE,
    MODULE_IDS.DB_BACKUP,
    MODULE_IDS.REMINDER,
    MODULE_IDS.YEAR_END_PROCESS
  ],

  DRAFT: [
    MODULE_IDS.DRAFT_DEBIT_NOTE_BILL_BASE,
    MODULE_IDS.DRAFT_CREDIT_NOTE_BILL_BASE
  ],
};

/**
 * Permission Types
 */
export const PERMISSION_TYPES = {
  VIEW: 'View',
  ADD: 'Add',
  EDIT: 'Edit',
  DELETE: 'Delete',
  PRINT: 'Print',
  EXPORT: 'Export',
  SAME_DATE_UPDATE: 'Same_Date_Update',
  VISIBLE: 'Visible',
};

/**
 * Helper function to get all module IDs from a group
 * @param {string} groupName - Name of the module group
 * @returns {Array} Array of module IDs
 */
export const getModuleIdsFromGroup = (groupName) => {
  return MODULE_GROUPS[groupName] || [];
};

/**
 * Helper function to get all module IDs
 * @returns {Array} Array of all module IDs
 */
export const getAllModuleIds = () => {
  return Object.values(MODULE_IDS);
};